import { useEffect, MutableRefObject, useState } from 'react';

/**
 * Given a ref and a handler, call the handler only when clicked on the ref'ed element
 */
export const useIntrinsicClick = (ref: MutableRefObject<unknown>) => {
  const [intrinsicClick, setIntrinsicClick] = useState(false);
  useEffect(() => {
    const handleMouseDown = (event: MouseEvent) => {
      if (ref.current === event.target) {
        setIntrinsicClick(true);
      }
      // Ignores events that are not from ref (i.e., events from descendant children)
      else {
        setIntrinsicClick(false);
      }
    };

    const handleMouseUp = (event: MouseEvent) => {
      if (ref.current === event.target) {
        setIntrinsicClick(false);
      }
    };

    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('mouseup', handleMouseUp);

    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  });

  return intrinsicClick;
};
